// src/Pages/CollectionPage/Collection.js
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom"; // ✅ for navigation
import "./collection.css";

const Collection = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "categories"));
        const fetchedCategories = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCategories(fetchedCategories);
      } catch (err) {
        console.error("❌ Error fetching categories:", err);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="collection-page">
      {/* Hero Section */}
      <section className="collection-hero">
        <h1>
          Our <span>Collection</span>
        </h1>
        <p>Explore timeless designs crafted with elegance & passion.</p>
      </section>

      {/* Categories Grid */}
      <section className="categories-grid">
        {categories.length > 0 ? (
          categories.map((cat) => (
            <div
              className="category-card"
              key={cat.id}
              onClick={() => navigate(`/collection/${cat.name}`)} // ✅ navigate
            >
              <div className="img-wrapper">
                <img src={cat.imageUrl} alt={cat.name} />
              </div>
              <h3>{cat.name}</h3>
            </div>
          ))
        ) : (
          <p className="loading-text">Loading collections...</p>
        )}
      </section>
    </div>
  );
};

export default Collection;
